import React, { useState } from "react";
import DescriptionIcon from "@material-ui/icons/Description";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useStyles } from "./styles";
import { API } from "../../../../tools/keys/keys";

const useDialogStyles = makeStyles({
  paper: {
    borderRadius: 16,
    padding: '16px 8px',
    minWidth: 380,
    backgroundColor: '#f0f4ff',
  },
  title: {
    textAlign: 'right',
    fontWeight: 'bold',
    fontSize: 24,
    color: '#1565c0',
    paddingBottom: 4,
  },
  subtitle: {
    textAlign: 'center',
    color: '#333',
    fontSize: 15,
    fontWeight: 500,
    marginBottom: 12,
  },
  infoBox: {
    backgroundColor: '#ddeeff',
    borderRadius: 12,
    padding: '4px 16px',
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0',
    borderBottom: '1px solid #c5d8f0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  infoLabel: {
    color: '#1565c0',
    fontWeight: 'bold',
    fontSize: 14,
  },
  infoValue: {
    color: '#333',
    fontSize: 14,
  },
  actions: {
    justifyContent: 'center',
    gap: 16,
    paddingTop: 20,
    paddingBottom: 8,
  },
  cancelBtn: {
    borderRadius: 50,
    border: '2px solid #333',
    color: '#333',
    padding: '8px 40px',
    fontWeight: 600,
    textTransform: 'none',
    fontSize: 15,
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  deleteBtn: {
    borderRadius: 50,
    backgroundColor: '#1e90ff',
    color: 'white',
    padding: '8px 40px',
    fontWeight: 600,
    textTransform: 'none',
    fontSize: 15,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#1565c0',
      boxShadow: 'none',
    },
  },
});

const Attachment = ({ element, onDelete }) => {
  const { original_name, path } = element;
  const classes = useStyles();
  const dialogClasses = useDialogStyles();
  const [open, setOpen] = useState(false);

  const handleDeleteClick = () => setOpen(true);
  const handleCancel = () => setOpen(false);
  const handleConfirm = () => {
    onDelete();
    setOpen(false);
  };

  return (
    <span className={`${classes.fileContainer}`}>
      <p>{original_name}</p>
      <a href={`${API + path}`} className={classes.link} target='blank'>
        <DescriptionIcon />
      </a>
      <DeleteIcon
        onClick={handleDeleteClick}
        style={{ cursor: 'pointer', color: '#f44336' }}
      />

      <Dialog
        open={open}
        onClose={handleCancel}
        classes={{ paper: dialogClasses.paper }}
      >
        <DialogTitle disableTypography className={dialogClasses.title}>
          למחוק קובץ מצורף
        </DialogTitle>

        <DialogContent>
          <DialogContentText className={dialogClasses.subtitle}>
            האם אתה בטוח שברצונך למחוק את הקובץ המצורף?
          </DialogContentText>
        </DialogContent>

        <DialogActions className={dialogClasses.actions}>
          <Button onClick={handleConfirm} className={dialogClasses.deleteBtn} variant="contained">
            מחק
          </Button>
          <Button onClick={handleCancel} className={dialogClasses.cancelBtn}>
            בטל
          </Button>
        </DialogActions>
      </Dialog>
    </span>
  );
};

export default Attachment;